import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import axios from '../api/axiosConfig';
import Sidebar from '../components/Sidebar';
import Navbar from '../components/Navbar';
import Pagination from '../components/Pagination';
import './Profiles.css'; // Reutilizamos estilos de perfiles o creamos Transitos.css

const Transitos = () => {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
  const [transitos, setTransitos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  
  // Estado para paginación
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  
  // Modales
  const [showModal, setShowModal] = useState(false);
  const [editingTransito, setEditingTransito] = useState(null);
  
  // Datos del formulario
  const [formData, setFormData] = useState({
    name: '',
    nit: '',
    address: '',
    phone: '',
    status: 'activo',
    plate_assignment_mode: 'automatico'
  });

  // Verificar superadmin o admin
  useEffect(() => {
    if (user?.role !== 'superadmin' && user?.role !== 'admin') {
      navigate('/dashboard');
    }
  }, [user, navigate]);

  useEffect(() => {
    fetchTransitos();
  }, []);

  const fetchTransitos = async () => {
    try {
      setLoading(true);
      const res = await axios.get('/api/transitos');
      setTransitos(res.data);
      setError('');
    } catch (err) {
      setError('Error al cargar tránsitos');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleOpenModal = (transito = null) => {
    if (transito) {
      setEditingTransito(transito);
      setFormData({
        name: transito.name,
        nit: transito.nit || '',
        address: transito.address || '',
        phone: transito.phone || '',
        status: transito.status,
        plate_assignment_mode: transito.plate_assignment_mode || 'automatico'
      });
    } else {
      setEditingTransito(null);
      setFormData({
        name: '',
        nit: '',
        address: '',
        phone: '',
        status: 'activo',
        plate_assignment_mode: 'automatico'
      });
    }
    setShowModal(true);
  };

  const handleSave = async (e) => {
    e.preventDefault();
    try {
      if (editingTransito) {
        await axios.put(`/api/transitos/${editingTransito.id}`, formData);
      } else {
        await axios.post('/api/transitos', formData);
      }
      fetchTransitos();
      setShowModal(false);
    } catch (err) {
      setError(err.response?.data?.message || 'Error al guardar tránsito');
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Lógica de paginación
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = transitos.slice(indexOfFirstItem, indexOfLastItem);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleItemsPerPageChange = (items) => {
    setItemsPerPage(items);
    setCurrentPage(1);
  };

  return (
    <div className="app-layout">
      <Sidebar />

      <div className="main-content">
        <Navbar title="🏢 Gestión de Tránsitos (Empresas)" />

        <div className="page-content">
          {error && <div className="error-banner">{error}</div>}

          <div className="page-header">
            <div className="header-title">
              <h2>Tránsitos Registrados</h2>
              <p className="subtitle">Organismos y empresas que operan en el sistema</p>
            </div>
            {user?.role === 'superadmin' && (
              <button onClick={() => handleOpenModal()} className="btn-primary">
                ➕ Nuevo Tránsito
              </button>
            )}
          </div>

          {loading ? (
            <p className="loading">Cargando tránsitos...</p>
          ) : (
            <div className="table-wrapper">
              <table className="users-table">
                <thead>
                  <tr>
                    <th>Nombre</th>
                    <th>NIT</th>
                    <th>Dirección</th>
                    <th>Asignación Placa</th>
                    <th>Estado</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {currentItems.map(t => (
                    <tr key={t.id}>
                      <td className="user-name">{t.name}</td>
                      <td>{t.nit}</td>
                      <td>{t.address}</td>
                      <td>
                        <span className={`plate-mode ${t.plate_assignment_mode}`}>
                          {t.plate_assignment_mode === 'automatico' ? '🤖 Automático' : '👤 Manual'}
                        </span>
                      </td>
                      <td>
                        <span className={`status ${t.status}`}>
                          {t.status}
                        </span>
                      </td>
                      <td className="actions">
                        <button 
                          onClick={() => handleOpenModal(t)} 
                          className="btn-action btn-edit"
                          title="Editar Tránsito"
                        >
                          ✏️ Editar
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              
              <Pagination 
                currentPage={currentPage}
                totalItems={transitos.length}
                itemsPerPage={itemsPerPage}
                onPageChange={handlePageChange}
                onItemsPerPageChange={handleItemsPerPageChange}
              />
            </div>
          )}
        </div>
      </div>

      {showModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3>{editingTransito ? 'Editar Tránsito' : 'Nuevo Tránsito'}</h3>
            <form onSubmit={handleSave}>
              <div className="form-group">
                <label>Nombre del Tránsito</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label>NIT</label>
                <input
                  type="text"
                  name="nit"
                  value={formData.nit}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <label>Dirección</label>
                <input
                  type="text"
                  name="address"
                  value={formData.address}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <label>Teléfono</label>
                <input
                  type="text"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <label>Modo de Asignación de Placas</label>
                <div className="radio-group">
                  <label>
                    <input
                      type="radio"
                      name="plate_assignment_mode"
                      value="automatico"
                      checked={formData.plate_assignment_mode === 'automatico'}
                      onChange={handleChange}
                    />
                    🤖 Automático (Siguiente disponible)
                  </label>
                  <label>
                    <input
                      type="radio"
                      name="plate_assignment_mode"
                      value="manual"
                      checked={formData.plate_assignment_mode === 'manual'}
                      onChange={handleChange}
                    />
                    👤 Manual (Escoger de la lista)
                  </label>
                </div>
              </div>
              {editingTransito && (
                <div className="form-group">
                  <label>Estado</label>
                  <select name="status" value={formData.status} onChange={handleChange}>
                    <option value="activo">Activo</option>
                    <option value="inactivo">Inactivo</option>
                  </select>
                </div>
              )}
              <div className="modal-actions">
                <button type="button" onClick={() => setShowModal(false)} className="btn-secondary">
                  Cancelar
                </button>
                <button type="submit" className="btn-primary">
                  {editingTransito ? 'Actualizar' : 'Crear'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Transitos;
